import { formatCnpjCpf } from "@/common/utils/formatters";
import { FiscalDocumentIssuerData } from "../types/fiscalDocumentIssuer.type";

const InssuanceData = ({ issuerData }: { issuerData?: FiscalDocumentIssuerData }) => {
  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-xl font-bold">Dados para emissão</h3>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">CNPJ/CPF</p>
          <p className="font-bold text-md">{issuerData?.fiscal_document_issuer_cnpj ? formatCnpjCpf(issuerData?.fiscal_document_issuer_cnpj) : 'Não informado'}</p>
        </div>

        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">Razão social</p>
          <p className="font-bold text-md">{issuerData?.fiscal_document_issuer_official_name || 'Não informado'}</p>
        </div>

        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">Inscrição estadual</p>
          <p className="font-bold text-md">{issuerData?.fiscal_document_issuer_state_inscription || 'Não informado'}</p>
        </div>
      </div>
    </div>
  );
};

export default InssuanceData;
